/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type StepDeliveryIndexPageQueryVariables = Exact<{ [key: string]: never; }>;


export type StepDeliveryIndexPageQuery = { stepDeliveries: Array<{ guid: string, name: string }> };

export type DeleteStepDeliveryMutationVariables = Exact<{
  input: string | number;
}>;


export type DeleteStepDeliveryMutation = { deleteStepDelivery: { void: any } };


export const StepDeliveryIndexPageDocument = gql`
    query StepDeliveryIndexPage {
  stepDeliveries {
    guid
    name
  }
}
    `;

/**
 * __useStepDeliveryIndexPageQuery__
 *
 * To run a query within a Vue component, call `useStepDeliveryIndexPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStepDeliveryIndexPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStepDeliveryIndexPageQuery();
 */
export function useStepDeliveryIndexPageQuery(options: VueApolloComposable.UseQueryOptions<StepDeliveryIndexPageQuery, StepDeliveryIndexPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<StepDeliveryIndexPageQuery, StepDeliveryIndexPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<StepDeliveryIndexPageQuery, StepDeliveryIndexPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<StepDeliveryIndexPageQuery, StepDeliveryIndexPageQueryVariables>(StepDeliveryIndexPageDocument, {}, options);
}
export function useStepDeliveryIndexPageLazyQuery(options: VueApolloComposable.UseQueryOptions<StepDeliveryIndexPageQuery, StepDeliveryIndexPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<StepDeliveryIndexPageQuery, StepDeliveryIndexPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<StepDeliveryIndexPageQuery, StepDeliveryIndexPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<StepDeliveryIndexPageQuery, StepDeliveryIndexPageQueryVariables>(StepDeliveryIndexPageDocument, {}, options);
}
export type StepDeliveryIndexPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<StepDeliveryIndexPageQuery, StepDeliveryIndexPageQueryVariables>;
export const DeleteStepDeliveryDocument = gql`
    mutation DeleteStepDelivery($input: ID!) {
  deleteStepDelivery(guid: $input) {
    void
  }
}
    `;

/**
 * __useDeleteStepDeliveryMutation__
 *
 * To run a mutation, you first call `useDeleteStepDeliveryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStepDeliveryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteStepDeliveryMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteStepDeliveryMutation(options: VueApolloComposable.UseMutationOptions<DeleteStepDeliveryMutation, DeleteStepDeliveryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteStepDeliveryMutation, DeleteStepDeliveryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteStepDeliveryMutation, DeleteStepDeliveryMutationVariables>(DeleteStepDeliveryDocument, options);
}
export type DeleteStepDeliveryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteStepDeliveryMutation, DeleteStepDeliveryMutationVariables>;